<template>
    <div>
        <button v-on:click="openPopup" v-html="label" :class="buttonClass"></button>
        <popup :visible="showPopup" :show-close-button="false">
            <abstract-manager v-if="loaded"
                :operations-url="operationsUrl"
                :topics="topics"
                :affiliationfields="affiliationfields"
                :authorfields="authorfields"
                :conference="conference"
                :guidelines="guidelines"
                :admin-mode="true"
                :participant-id="this.participant_id"
                              v-on:cancel="hidePopup"
                ></abstract-manager>
        </popup>
    </div>
</template>

<script>
import Popup from "./Popup";
import AbstractManager from "./AbstractManager";
export default {
    name: "AbstractEditorPopup",
    components: {AbstractManager, Popup},
    props: {
        operationsUrl: {type: String},
        ajaxUrl: {type: String},
        abstractId: {type: Number},
        label: {type: String},
        buttonClass: {type: String}
    },
    data: function() {
        return {
            showPopup: false,
            loaded: false,
            topics: [],
            affiliationfields: [],
            authorfields: [],
            conference: {},
            guidelines: {},
            participant_id: -1
        }
    },
    methods: {
        openPopup: function() {
            this.loaded = false;
            window.axios.post(this.ajaxUrl, {action: 'fetchEditingBasedata', subject: this.abstractId})
                .then((response) => {
                    this.participant_id = response.data.participant_id;
                    this.topics = response.data.topics;
                    this.affiliationfields = response.data.affiliationfields;
                    this.authorfields = response.data.authorfields;
                    this.conference = response.data.conference;
                    this.guidelines = response.data.guidelines;
                    this.showPopup = true;
                    this.loaded = true;
                }).catch((error) => {
                    alert(error);
                })

        },
        hidePopup: function() {
            this.showPopup = false;
        }
    }
}
</script>

<style scoped>

</style>